/* src/app/modules/dna-syngovia/components/dna-syngovia-group-node-card/dna-syngovia-group-node-card.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: block;
}
.card-server {
  outline: 0.125rem solid rgba(var(--ui-1), var(--opacity-6));
  border: none;
  border-radius: 0.25rem;
  background-color: #FFFFFF;
  width: calc(100% - 0.25rem);
  height: calc(100% - 0.25rem);
  min-height: 380px;
  padding: 1rem;
  margin: 0.125rem;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: calc(var(--gap) * 2);
  align-items: flex-start;
}
.card-server:hover {
  cursor: pointer;
  background-color: var(--base-2);
}
.card-server:hover .card-server__header sh-text {
  color: rgba(var(--ui-1), var(--opacity-2));
}
.card-server.card-selected {
  outline: 0.125rem solid rgb(var(--ui-2));
  background-color: var(--ui-7);
}
.card-server.card-selected .card-server__header sh-text {
  color: rgba(var(--ui-1), var(--opacity-2));
}
.card-server:focus-visible {
  background-color: var(--base-2);
}
.card-server__header-grid {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--gap);
  align-self: stretch;
}
.card-server__header {
  height: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  align-self: center;
}
.card-server__main {
  display: flex;
  padding: 0 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: calc(var(--gap) * 0.5);
  align-self: stretch;
  text-align: center;
}
.card-server__main sh-text {
  font-weight: 400;
}
.card-server__main img {
  width: 76.111px;
  height: 80px;
}
.card-server__items {
  display: grid;
  grid-column-gap: calc(var(--gap) * 2);
  grid-template-columns: 1fr 1fr;
  grid-row-gap: calc(var(--gap) * 2);
  justify-content: center;
  align-self: center;
}
.server__item {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  gap: calc(var(--gap) * 0.5);
  align-items: center;
  border: none;
  background: transparent;
  cursor: pointer;
}
.server__item img {
  width: 57.083px;
  height: 60px;
}
.server__item sh-text {
  font-weight: 400;
}
.server__item:hover sh-text {
  text-decoration: underline;
}
.server-icon__warning {
  position: absolute;
  margin-left: 64px;
  margin-top: -10px;
}
.server__item-icon__warning {
  position: absolute;
  margin-left: 54px;
  margin-top: -10px;
}
.healthcheck-server-button {
  height: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.75rem 0.5rem 0.75rem 1rem;
  cursor: pointer;
  border: 0.0625rem solid rgba(var(--ui-1), var(--opacity-6));
  border-radius: 0.25rem;
  background-color: rgb(var(--ui-7));
  position: absolute;
  right: 0.625rem;
  left: 0.625rem;
  bottom: 0.625rem;
}
.healthcheck-server-button:hover sh-text {
  color: rgba(var(--ui-1), var(--opacity-3));
}
.healthcheck-server-button:hover .healthcheck-title {
  text-decoration: underline;
}
.healthcheck-server-button:focus-visible {
  outline: var(--focus-outline);
}
.healthcheck-server-info {
  width: 70%;
  text-align: start;
}
.healthcheck-server-info .healthcheck-title {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.75rem;
}
.healthcheck-server-info .healthcheck-serial-number {
  font-weight: 400;
}
.healthcheck-score-container {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}
.healthcheck-score-container .healthcheck-score {
  font-size: 1.5rem;
  line-height: 1.75rem;
  font-weight: 700;
}
.card-node {
  outline: 0.125rem solid rgba(var(--ui-1), var(--opacity-6));
  border: none;
  border-radius: 0.25rem;
  background-color: var(--ui-7);
  width: calc(100% - 0.25rem);
  height: fit-content;
  padding: 0.5rem 0.5rem 1rem 0.5rem;
  margin: 0.125rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.75rem;
}
.card-node:hover {
  cursor: pointer;
  background-color: var(--base-2);
}
.card-node:hover .card-node__header-description {
  color: rgba(var(--ui-1), var(--opacity-2));
}
.card-node.card-selected {
  outline: 0.125rem solid rgb(var(--ui-2));
  background-color: var(--ui-7);
}
.card-node.card-selected .card-node__header-description {
  color: rgba(var(--ui-1), var(--opacity-2));
}
.card-node:focus-visible {
  background-color: var(--base-2);
}
.card-node--dicom_proxy {
  width: calc(100% - 0.25rem);
}
.card-node__items {
  display: flex;
  flex-wrap: nowrap;
  height: 2.75rem;
}
.grow {
  flex-grow: 1;
}
.card-node__header {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.5rem;
  height: 1.5rem;
}
.card-node__header-description {
  width: max-content;
  height: fit-content;
  white-space: nowrap;
}
.card-selected {
  outline: 0.125rem solid rgb(var(--ui-2));
}
/*# sourceMappingURL=dna-syngovia-group-node-card.component.css.map */
